import React from 'react'

export default function MarketingIconReliability (props) {
  return (
    <svg
      width="81"
      height="71"
      viewBox="0 0 81 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3044 64.0002C42.3724 62.7801 40.5619 61.6753 38.8772 60.6472C28.5869 54.3675 22.9841 50.9484 22.9841 41.5784V14.2528C31.3132 14.2528 36.3188 13.9354 44.3044 7.14601C52.2901 13.9354 57.2956 14.2528 65.6247 14.2528V41.5784C65.6247 50.9484 60.0219 54.3675 49.7316 60.6472C48.0469 61.6753 46.2365 62.7801 44.3044 64.0002Z"
        fill="#61C9D7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1042 63.8542C34.1722 62.6341 32.3617 61.5293 30.677 60.5011C20.3867 54.2215 14.7839 50.8024 14.7839 41.4323V14.1068C23.113 14.1068 28.1186 13.7893 36.1042 7C44.0899 13.7893 49.0954 14.1068 57.4245 14.1068V41.4323C57.4245 50.8024 51.8217 54.2215 41.5315 60.5011C39.8467 61.5293 38.0363 62.6341 36.1042 63.8542Z"
        fill="#1D1F21"
      />
      <path
        d="M15.4035 33.9694C15.4035 22.6977 24.541 13.5602 35.8127 13.5602C47.0844 13.5602 56.2219 22.6977 56.2219 33.9694C56.2219 45.2411 47.0844 54.3786 35.8127 54.3786C24.541 54.3786 15.4035 45.2411 15.4035 33.9694Z"
        fill="#1D1F21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5559 39.5876L46.9742 29.1693L44.0313 26.2265L33.613 36.6448L29.1599 32.1916L26.217 35.1345L30.6701 39.5876L30.6696 39.5882L33.6125 42.531L33.613 42.5305L33.6146 42.5322L36.5575 39.5893L36.5559 39.5876Z"
        fill="#5CEBA0"
      />
      <rect
        opacity="0.01"
        x="0.5"
        y="0.5"
        width="80"
        height="70"
        stroke="white"
      />
    </svg>
  )
}
